// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C-o_","option":"styles_option__244BH","active":"styles_active__1oXjp"};